// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"3606b932","845":"a3da9151"}[chunkId] + ".chunk.js";
};